/** @format */

export const isObject = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value);
};

// https://yadro.top/5229-sklonenie-slov-na-javascript.html
export const inflectNoun = (number: number, one: string, two: string, five: string): string => {
  let rem = number % 100;
  if (rem >= 5 && rem <= 20) return five;

  rem = rem % 10;
  if (rem === 1) return one;
  if (rem >= 2 && rem <= 4) return two;

  return five;
};

/**
 * Вернёт name для графика в формате 0001
 * @param num
 * @returns {string}
 */

export const generateGraphPointName = (num: number): string => {
  if (num < 0) {
    throw new Error('Число должно быть неотрицательным.');
  }

  const numStr = String(num);

  if (numStr.length > 4) {
    return numStr;
  }

  return numStr.padStart(4, '0');
};

/**
 * Вернёт исходный индекс от pointName
 * @param pointName
 * @returns {number}
 */

export const getIndexFromPointName = (pointName: string): number => {
  if (pointName === '0000') {
    return 0;
  }

  let result = '';

  pointName.split('').forEach(digit => {
    if (digit !== '0' || result.length > 0) {
      result += digit;
    }
  });

  const parsed = parseInt(result);

  if (isNaN(parsed)) {
    throw new Error('Invalid point name');
  }

  return parsed;
};

/**
 * Безопасный парсинг JSON.parse.
 * Для более безопасной типизации используйте гарды.
 * @param json
 * @param guardFn
 */

export const safeParseJson = <D>(
  json: unknown,
  guardFn: (parsed: unknown) => parsed is D,
): D | null => {
  if (typeof json !== 'string') {
    return null;
  }

  try {
    const parsed = JSON.parse(json);
    if (guardFn(parsed)) {
      return parsed;
    } else {
      return null;
    }
  } catch {
    return null;
  }
};
